/* Reducers for meta component of Redux state. See src/interfaces/state/index.ts for more information */
import { IMeta } from '../../interfaces';
import { Interfaces, Constants } from '../../actions/meta';
export type ActionType = Interfaces.IAddTab & Interfaces.IAddUsers & Interfaces.IAddStates &
    Interfaces.IAddCountries & Interfaces.IAddField & Interfaces.IAddFormTitle & Interfaces.IUpdateFields &
    Interfaces.IGetAllGroupUsers;

const initial: IMeta = {
    tabs: {},
    isLoading: false,
    fields: {},
    users: [],
    states: [],
    countries: [],
    title: '',
    groupUsers: null
};

export function meta(state: IMeta = initial, action: ActionType): IMeta {
    switch (action.type) {
        case Constants.ADD_FIELD:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.field.id]: action.field
                }
            };
        case Constants.ADD_USERS:
            return {
                ...state,
                users: action.users
            };
        case Constants.ADD_STATES:
            return {
                ...state,
                states: action.states
            };
        case Constants.ADD_COUNTRIES:
            return {
                ...state,
                countries: action.countries
            };
        case Constants.ADD_TAB:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    [action.tab.id]: action.tab
                }
            };
        case Constants.UPDATE_FIELDS:
            return {
                ...state,
                fields: {
                ...state.fields,
                ...action.fields
                }
            };
      case Constants.ADD_FORM_TITLE:
        return {
          ...state,
          title: action.title
        };
      case Constants.ADD_ALL_GROUP_USERS:
        return {
            ...state,
            groupUsers: action.groupUsers
        };
        default:
            return state;
    }
}
